import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import AnalyticsDashboard from './pages/analytics-dashboard';
import EmailCampaignManager from './pages/email-campaign-manager';
import MediaContacts from './pages/media-contacts';
import Login from './pages/login';
import Dashboard from './pages/dashboard';
import AIContentCreator from './pages/ai-content-creator';
import PressKitBuilder from './pages/press-kit-builder';
import EnhancedPressKitBuilder from './pages/enhanced-press-kit-builder';
import Register from './pages/register';
import PRDistribution from './pages/pr-distribution';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Dashboard />} />
        <Route path="/analytics-dashboard" element={<AnalyticsDashboard />} />
        <Route path="/email-campaign-manager" element={<EmailCampaignManager />} />
        <Route path="/media-contacts" element={<MediaContacts />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/ai-content-creator" element={<AIContentCreator />} />
        <Route path="/press-kit-builder" element={<PressKitBuilder />} />
        <Route path="/enhanced-press-kit-builder" element={<EnhancedPressKitBuilder />} />
        <Route path="/register" element={<Register />} />
        <Route path="/pr-distribution" element={<PRDistribution />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;